// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { GeneratedAnalyticsMetadataInputClearInput } from '../../input/analytics-metadata/interfaces';
export type GeneratedAnalyticsMetadataTextFilterClearInput = GeneratedAnalyticsMetadataInputClearInput;

export interface GeneratedAnalyticsMetadataTextFilterComponent {
  name: 'awsui.TextFilter';
  label: string;
  properties: {
    disabled: string;
    filteringText: string;
  };
}
